import { usePaginatedApi } from "../../../swr/useApi";

import { partnersService } from "../../api_client";
import type {
    PartnerDto,
    PartnersQueryDto,
} from "../../../api";

export function usePartners(query?: PartnersQueryDto) {
    return usePaginatedApi<PartnerDto, PartnersQueryDto>({
        key: "partners",
        serviceMethod: async (queryParams) => await partnersService.findAll(queryParams),
        query: query,
    });
}

